module.exports = __webpack_public_path__ + "img/thumbnail.ee2b96ea.jpg";